import script from "./PageTitleBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageTitleBar.vue?vue&type=script&lang=ts&setup=true"

import "./PageTitleBar.vue?vue&type=style&index=0&id=61b6dc3f&lang=less"

const __exports__ = script;

export default __exports__